import { SelectFieldProps } from '../Fields';
import { StyledTag } from '../Fields.styled';

export const SingleSelectText = ({ attributes, fieldValue }: SelectFieldProps) => {
	const selectConfig = attributes.enumConfig;
	const activeStatus = fieldValue;
	const getBadge = (badgeType: string, children: React.ReactNode) => {
		if (badgeType) {
			return (
				<StyledTag bordered={false} badgeType={badgeType}>
					{children}
				</StyledTag>
			);
		}
		return null;
	};
	const currentSelectConfig = selectConfig![activeStatus];

	if (!currentSelectConfig) {
		return null;
	}

	return <>{getBadge(currentSelectConfig.badgeType, currentSelectConfig.displayName)}</>;
};
